import ActionButton from "@/src/components/misc/action-elements/action-button/action-button"
import ImageFallback from "../../image-fallback/image-fallback"
import SvgClose from '@/src/assets/svgs/collection/close.svg'
import styles from "./styles.module.scss"
import { ReactNode } from "react"

type CustomInstallPopupProps = {
  isOpen: boolean
  logoUrl: string
  merchantName: string
  mainText: string
  subText: ReactNode
  onClose: () => void
  onInstall: () => void
  cancelLabel?: string
  installLabel?: string
  mainTextId?: string
}

export const CustomInstallPopup = ({
  isOpen,
  logoUrl,
  merchantName,
  mainText,
  subText,
  onClose,
  onInstall,
  installLabel = "Adicionar",
  mainTextId,
}: CustomInstallPopupProps) => {
  if (!isOpen) return null

  return (
    <div id="popup-custom" className={styles.popupCustom}>
      <div className={styles.contentPopup}>
        <div className={styles.popupTitle}>
          <ImageFallback
            src={`${logoUrl}`}
            alt={`Logo ${merchantName}`}
          />
          <p id={mainTextId}>{mainText}</p>
          <div onClick={() => onClose()} className={styles.btnClose}>
            <SvgClose />
          </div>
        </div>
        <div className={styles.subText}>
          <p>{subText}</p>
        </div>
        <div className={styles.popupButtons}>
          <ActionButton onClick={() => { onInstall(); onClose() }} theme='primary' size='medium'>{installLabel}</ActionButton>
        </div>
      </div>
    </div>
  )
}